<template>
  <div class="product-container10">
    <app-navigation></app-navigation>
    <section id="company-story" role="region" aria-labelledby="company-story-title" class="company-story-section policy-section">
      <div class="policy-wrapper">
        <h2 id="company-story-title">{{ $t('policy.title') }}</h2><br>

        <p>{{ $t('policy.subtitle') }}</p>
        <h4>{{ $t('policy.article1.title') }}</h4>
        <p>{{ $t('policy.article1.sections[0]') }}</p>
        <p>{{ $t('policy.article1.sections[1]') }}</p><br>
        <h4>{{ $t('policy.article2.title') }}</h4>
        <p>{{ $t('policy.article2.sections[0]') }}</p><br>
        <h4>{{ $t('policy.article3.title') }}</h4>
        <p>{{ $t('policy.article3.sections[0]') }}</p>
        <p>{{ $t('policy.article3.sections[1]') }}</p>
        <p>{{ $t('policy.article3.sections[2]') }}</p>
        <p>{{ $t('policy.article3.sections[3]') }}</p>
        <p>{{ $t('policy.article3.sections[4]') }}</p><br>
        <h4>{{ $t('policy.article4.title') }}</h4>
        <p>{{ $t('policy.article4.sections[0]') }}</p>
        <p>{{ $t('policy.article4.sections[1]') }}</p><br>
        <h4>{{ $t('policy.article5.title') }}</h4>
        <h4>{{ $t('policy.article5.subtitle') }}</h4>
        <p>{{ $t('policy.article5.sections[0]') }}</p>
        <ul class="policy-list">
          <li v-for="(option, index) in $tm('policy.article5.options', {}, { returnObjects: true })"
              :key="index">
            {{ option }}
          </li>
        </ul>
        <br>
        <p>{{ $t('policy.article5.sections[1]') }}</p>
        <p>{{ $t('policy.article5.sections[2]') }}</p>
        <p>{{ $t('policy.article5.sections[3]') }}</p>
        <p>{{ $t('policy.article5.sections[4]') }}</p><br>
        <h4>{{ $t('policy.article6.title') }}</h4>
        <p>{{ $t('policy.article6.sections[0]') }}</p>
        <p>{{ $t('policy.article6.sections[1]') }}</p><br>
        <h4>{{ $t('policy.article7.title') }}</h4>
        <p>{{ $t('policy.article7.sections[0]') }}</p>
        <p>{{ $t('policy.article7.sections[1]') }}</p>
        <p>{{ $t('policy.article7.sections[2]') }}</p>
        <p>{{ $t('policy.article7.sections[3]') }}</p>
        <p>{{ $t('policy.article7.sections[4]') }}</p><br>
        <h4>{{ $t('policy.article8.title') }}</h4>
        <p>{{ $t('policy.article8.sections[0]') }}</p><br>
        <h4>{{ $t('policy.article9.title') }}</h4>
        <p>{{ $t('policy.article9.sections[0]') }}</p><br>
        <h4>{{ $t('policy.article10.title') }}</h4>
        <p>{{ $t('policy.article10.sections[0]') }}</p>
        <p>{{ $t('policy.article10.sections[1]') }}</p>
        <p>{{ $t('policy.article10.sections[2]') }}</p><br>
        <h4>{{ $t('policy.article11.title') }}</h4>
        <h4>{{ $t('policy.article11.article11_1.title') }}</h4>
        <p>{{ $t('policy.article11.article11_1.sections[0]') }}</p>
        <p>{{ $t('policy.article11.article11_1.sections[1]') }}</p>
        <p>{{ $t('policy.article11.article11_1.sections[2]') }}</p><br>
        <h4>{{ $t('policy.article11.article11_2.title') }}</h4>
        <p>{{ $t('policy.article11.article11_2.sections[0]') }}</p><br>
        <h4>{{ $t('policy.article11.article11_3.title') }}</h4>
        <p>{{ $t('policy.article11.article11_3.sections[0]') }}</p>
        <p>{{ $t('policy.article11.article11_3.sections[1]') }}</p>
        <ul class="policy-list">
          <li v-for="(option, index) in $tm('policy.article11.article11_3.options', {}, { returnObjects: true })"
              :key="index">
            {{ option }}
          </li>
        </ul>
        <br>
        <p>{{ $t('policy.article11.article11_3.sections[2]') }}</p><br>
        <h4>{{ $t('policy.article11.article11_4.title') }}</h4>
        <p>{{ $t('policy.article11.article11_4.sections[0]') }}</p>
        <p>{{ $t('policy.article11.article11_4.sections[1]') }}</p>
        <p>{{ $t('policy.article11.article11_4.sections[2]') }}</p>
        <p>{{ $t('policy.article11.article11_4.sections[3]') }}</p>
        <p>{{ $t('policy.article11.article11_4.sections[4]') }}</p><br>

      </div>
    </section>
    <app-footer></app-footer>
  </div>
</template>

<script>
import AppNavigation from "../components/navigation.vue";
import AppFooter from "../components/footer.vue";

export default {
  name: "Policy",
  props: {},
  components: {AppNavigation, AppFooter},
  methods: {
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    }    
  }
};
</script>

<style scoped>
.policy-section .policy-wrapper {
  grid-column: 1 / -1; /* span over beide kolommen */
}

.policy-section {
  flex-direction: column;
}

.policy-list {
  margin-left: 20px;
}
</style>